export interface MarkdownTable {
  header: string[];
  alignments: ("left" | "right" | "center")[];
  rows: string[][];
}

const SEPARATOR_CELL_PATTERN = /^\s*:?-+:?\s*$/;

export function isTableStart(
  line: string,
  nextLine: string | undefined,
): boolean {
  if (!line.startsWith("|")) {
    return false;
  }
  if (nextLine === undefined) {
    return false;
  }
  return isSeparatorLine(nextLine);
}

export function parseMarkdownTable(lines: string[]): MarkdownTable {
  const header = splitRow(lines[0]).map((cell) => cell.trim());
  const alignments = splitRow(lines[1]).map(parseAlignment);
  const rows = lines
    .slice(2)
    .map((line) => normalizeRowLength(splitRow(line), header.length));

  return {
    header,
    alignments: header.map((_, i) => alignments[i] ?? "left"),
    rows,
  };
}

function isSeparatorLine(line: string): boolean {
  const cells = splitRow(line);
  return (
    cells.length > 0 && cells.every((cell) => SEPARATOR_CELL_PATTERN.test(cell))
  );
}

function splitRow(line: string): string[] {
  let trimmed = line.trim();
  if (trimmed.startsWith("|")) {
    trimmed = trimmed.slice(1);
  }
  if (trimmed.endsWith("|")) {
    trimmed = trimmed.slice(0, -1);
  }
  return trimmed.split("|");
}

function parseAlignment(cell: string): "left" | "right" | "center" {
  const trimmed = cell.trim();
  const isLeftMarked = trimmed.startsWith(":");
  const isRightMarked = trimmed.endsWith(":");
  if (isLeftMarked && isRightMarked) {
    return "center";
  }
  if (isRightMarked) {
    return "right";
  }
  return "left";
}

function normalizeRowLength(cells: string[], length: number): string[] {
  const trimmed = cells.map((cell) => cell.trim()).slice(0, length);
  while (trimmed.length < length) {
    trimmed.push("");
  }
  return trimmed;
}
